const init = () => {
	const forms = document.querySelectorAll('.signUpForm');

	// initialiser
	const initialise = () => {
		forms.forEach(form => {
			const formFields = form.querySelectorAll('input:not([type="hidden"]), select');
			const submitBtn = form.querySelector('.btn--submit');
			submitBtn.addEventListener('click', (e) => {
				e.preventDefault();
				e.target.disabled = true;
				e.target.style.opacity = "0.5";
				let isFormValid = validateFormFields(formFields);
				// if form is valid submit if not focus on first input with error
				isFormValid ? submitForm(form) : form.querySelector('[aria-invalid="true"]').focus()
			})
		});

		//Parse URL parameters and store as cookies
		const cookies = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (let i = 0; i < cookies.length; i++) {
			document.cookie = cookies[i] + ' ;path=/';

			if (typeof localStorage !== 'undefined') {
				var item = cookies[i].split('=');
				localStorage.setItem(item[0], item[1]);
			}
		}

		if ( ! getCookie( 'EntryURL' ) ) {
			setCookie( 'EntryURL', document.location.href );
		}

		if ( ! getLS('EntryURL') && typeof localStorage !== 'undefined' ) {
			localStorage.setItem( 'EntryURL', document.location.href );
		}
	}

	const validateFormFields = (fields) => {
		let invalidFields = [];
		fields.forEach(field => {
			const fieldType = field.getAttribute('type') ? field.getAttribute('type') : 'select';
			const fieldValue = field.value;
			let fieldValidLength = checkFieldLength(fieldValue);

			// check field length
			if (!fieldValidLength) {
				setInvalidFields(field)
				invalidFields.push(field);
				return false
			}

			// check if field is email
			if (fieldType === 'email') {
				let fieldValidEmail = validateEmail(fieldValue)
				if (!fieldValidEmail) {
					setInvalidFields(field);
					invalidFields.push(field);
					return false
				}
			}

			// check if field is number
			if (fieldType === 'tel') {
				let fieldValidTelephone = validateTelephone(fieldValue)
				if (!fieldValidTelephone) {
					setInvalidFields(field);
					invalidFields.push(field);
					return false
				}
			}

			// Remove invalid attributes
			removeInvalidFields(field);
			return true
		})
		return !invalidFields.length
	}

	const submitForm = (form) => {
		const data = new FormData();
		data.append('school', 'AV5');
		data.append('campus', form.campus.value);
		data.append('program', form.program.value);
		data.append('schedule', form.schedule.value);
		data.append('first', form.first.value);
		data.append('last', form.last.value);
		data.append('email', form.email.value);
		data.append('phone', form.phone.value);
		data.append('vendor', getCookie('vendor') || getCookie('source') || getLS('vendor') || getLS('source') || getQS('vendor') || getQS('source') || 'Microsite');
		data.append('entry_url', getCookie('EntryURL') || getLS('EntryURL') || '');
		data.append('submitted_from', window.location.href);

		try {
			fetch('https://leads.dev-q.com/api/leads', {
					method: 'POST',
					cache: 'no-cache', // Stop any form cache if user resubmits form.
					body: data
				})
				.then(() => {
					let pWrapper = document.createElement('p');
					pWrapper.classList.add('signUpForm', 'signUpForm--thankyou');
					pWrapper.append('Thank you for your interest in Avenue Five, we will be in touch shortly.');
					form.parentNode.append(pWrapper);
					form.classList.add('signUpForm--hidden')

					if (typeof dataLayer !== 'undefined') {
						dataLayer.push({'event': 'rfi_submit'});
					}
					fetch('/conversion.html');
				})
		} catch (e) {
			console.log(e);
		}
	}

	/* 
	######################
	######################
	Utility functions
	######################
	######################
	*/
	const checkFieldLength = (value) => {
		if (!value.length || value.length < 1) return false
		return true
	}

	const validateTelephone = (value) => {
		let valueToNum = value.replace(/\D/g, '');
		if (!valueToNum.length || valueToNum.length < 10) return false
		return true
	}

	const validateEmail = (value) => {
		const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(value);
	}

	const setInvalidFields = (field) => {
		field.closest('.inputItem').classList.add('inputItem--invalid');
		field.setAttribute('aria-invalid', true)
	}

	const removeInvalidFields = (field) => {
		field.closest('.inputItem').classList.remove('inputItem--invalid');
		field.setAttribute('aria-invalid', false)
	}

	function setCookie(name, value, days) {
		var expires;
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		} else {
			expires = "";
		}
		document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
	}

	const getCookie = (name) => {
		return document.cookie.split("; ").reduce(function (r, v) {
			var parts = v.split("=");
			return parts[0] === name ? decodeURIComponent(parts[1]) : r;
		}, "");
	}

	function getLS(name) {
		return localStorage.getItem(name);
	}

	function getQS(name) {
		return new URL(window.location.href).searchParams.get(name);
	}
	/* 
	######################
	######################
	Utility functions
	######################
	######################
	*/

	// init
	initialise();
}


function ready(init) {
	if (document.readyState != 'loading') {
		init();
	} else {
		document.addEventListener('DOMContentLoaded', init);
	}
}

ready(init);
